export default[
    {
        path: '/course',
        name: 'course',
        redirect:'/course/soncourse',
        component: () => import('@/views/my/course.vue'),
        children: [
            {
              path: 'soncourse',
              name: 'soncourse',
              component: () => import('@/views/my/coursezi/soncourse.vue'),
            },
            {
                path: 'soncollection',
                name: 'soncollection',
                component: () => import('@/views/my/coursezi/soncollection.vue'),
            },
            {
              path: 'sonlearning',
              name: 'sonlearning',
              component: () => import('@/views/my/coursezi/sonlearning.vue'),
            },
            {
              path: 'sonevaluation',
              name: 'sonevaluation',
              component: () => import('@/views/my/coursezi/sonevaluation.vue'),
            },
            {
                path: 'sonclass',
                name: 'sonclass',
                component: () => import('@/views/my/coursezi/sonclass.vue'),
            },
            
        ]
    },
    {
      path: '/toevaluates',
      name: 'toevaluates',
      component: () => import('@/views/my/coursezi/toevaluates.vue'),
    },
    {
        path: '/sonclasslist',
        name: 'sonclasslist',
        component: () => import('@/views/my/sonclasslist.vue'),
    },
]